import { darken } from '@mui/material/styles'
import type { BrandingColors } from './types'

/** Malu default theme tokens used when white-label branding is disabled. */
export const MALU_THEME = {
  primary: '#23A9C2',
  secondary: '#E1BF92',
  secondaryLight: '#F7E7D3',
  background: '#FFFFFF',
  lightBackground: '#F3F3F3',
  contrastText: '#FFFFFF',
  text: '#000000',
  textDarkBackground: '#303030',
  greyOut: '#A0A0A0',
  success: '#4caf50',
  error: '#C12C2C',
  linkLight: '#FFFFFF',
  linkDark: '#000000',
} as const

export const DEFAULT_BRANDING_COLORS: BrandingColors = {
  accentColor: MALU_THEME.primary,
  timerChipBackgroundColor: MALU_THEME.primary,
  timerChipTextColor: MALU_THEME.contrastText,
  footerTextColor: MALU_THEME.contrastText,
  footerTextHoverColor: darken(MALU_THEME.secondary, 0.2),
  headerBackgroundColor: MALU_THEME.secondary,
  emailHeaderBackgroundColor: MALU_THEME.secondary,
  footerBackgroundColor: MALU_THEME.secondary,
  pageBackgroundColor: MALU_THEME.background,
  buttonColor: MALU_THEME.primary,
  buttonTextColor: MALU_THEME.contrastText,
  highlightChipBackgroundColor: MALU_THEME.secondary,
  highlightChipTextColor: MALU_THEME.text,
}
